
























































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { marked } from 'marked'

const API_URL = process.env.VUE_APP_NOVIDADES_API_URL || ''

const CAT_STYLES: Record<string, { background: string; color: string }> = {
	'Caixa':             { background: '#EAF1FB', color: '#2B5FA3' },
	'Fiscal':            { background: '#FCEFE3', color: '#9A5B1F' },
	'Cashback':          { background: '#EAF7E1', color: '#3F7D1C' },
	'Títulos/Crediário': { background: '#F1E9FA', color: '#6A2FA0' },
	'Integrações':       { background: '#E4F5F4', color: '#177A74' },
	'Demonstração':      { background: '#EDEDED', color: '#5F5F5F' },
}

interface Release {
	id: string; title: string; desc: string; content?: string
	categories?: string[]; category?: string  // category mantido p/ compat com dados antigos
	year: string; month: string; monthOrder: number; dateLabel: string
}

@Component
export default class ListaDeNovidades extends Vue {
	carregando = false
	releases: Release[] = []
	search = ''
	activeCategory = 'all'
	selectedYearIdx = 0
	selectedMonth: string | null = null
	detailOpen = false
	detailRelease: Release | null = null

	get apiConfigurada() { return !!API_URL }

	relCats(r: Release): string[] {
		return r.categories ?? (r.category ? [r.category] : [])
	}

	get categories(): string[] {
		return [...new Set([...Object.keys(CAT_STYLES), ...this.releases.flatMap(r => this.relCats(r))])]
	}

	get filteredReleases(): Release[] {
		const q = (this.search || '').trim().toLowerCase()
		return this.releases
			.filter(r => this.activeCategory === 'all' || this.relCats(r).includes(this.activeCategory))
			.filter(r => !q || r.title.toLowerCase().includes(q) || (r.desc || '').toLowerCase().includes(q) || r.id.toLowerCase().includes(q))
	}

	get yearGroups() {
		const map: Record<string, Record<string, { month: string; monthOrder: number; items: Release[] }>> = {}
		for (const r of this.filteredReleases) {
			if (!map[r.year]) map[r.year] = {}
			if (!map[r.year][r.month]) map[r.year][r.month] = { month: r.month, monthOrder: Number(r.monthOrder), items: [] }
			map[r.year][r.month].items.push(r)
		}
		return Object.keys(map)
			.sort((a, b) => Number(b) - Number(a))
			.map(year => ({
				year,
				months: Object.values(map[year]).sort((a, b) => b.monthOrder - a.monthOrder),
			}))
	}

	get currentYear() { return this.yearGroups[this.selectedYearIdx] ?? null }

	get visibleItems(): Release[] {
		if (!this.currentYear) return []
		const items = this.filteredReleases.filter(r => r.year === this.currentYear!.year)
		return this.selectedMonth ? items.filter(r => r.month === this.selectedMonth) : items
	}

	get visibleMonthGroups() {
		const map: Record<string, { month: string; monthOrder: number; items: Release[] }> = {}
		for (const r of this.visibleItems) {
			if (!map[r.month]) map[r.month] = { month: r.month, monthOrder: Number(r.monthOrder), items: [] }
			map[r.month].items.push(r)
		}
		return Object.values(map).sort((a, b) => b.monthOrder - a.monthOrder)
	}

	get areaCounts() {
		const q = (this.search || '').trim().toLowerCase()
		const base = this.releases.filter(r => !q || r.title.toLowerCase().includes(q) || (r.desc || '').toLowerCase().includes(q))
		const all = [
			{ key: 'all', label: 'Todas', count: base.length, dot: null },
			...this.categories
				.filter(c => base.some(r => this.relCats(r).includes(c)))
				.map(c => ({
					key: c, label: c,
					count: base.filter(r => this.relCats(r).includes(c)).length,
					dot: (CAT_STYLES[c] || {}).color || '#888',
				})),
		]
		return all
	}

	selectArea(key: string) {
		this.activeCategory = key
		this.selectedMonth = null
	}

	openDetail(release: Release) {
		this.detailRelease = release
		this.detailOpen = true
	}

	renderMd(text: string) {
		if (!text) return ''
		return marked.parse(text, { breaks: true }) as string
	}

	catStyle(category: string) {
		return CAT_STYLES[category] || { background: '#EDEDED', color: '#5F5F5F' }
	}

	@Watch('selectedYearIdx')
	onYearChange() { this.selectedMonth = null }

	@Watch('activeCategory')
	onCategoryChange() { this.selectedMonth = null }

	async created() {
		if (!API_URL) return
		this.carregando = true
		try {
			const res = await fetch(`${API_URL}/novidades`)
			this.releases = await res.json()
		} catch {
			AlertModule.setError('Não foi possível carregar as novidades.')
		} finally {
			this.carregando = false
		}
	}
}
